"use client";

import React from "react";
import GenericSubstantiveProcedures from "../../substantive-procedures/GenericSubstantiveProcedures";

interface RevenueFromOperationsSubstantiveProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
}

export default function RevenueFromOperationsSubstantive({
  onBack,
  setActiveSection,
}: RevenueFromOperationsSubstantiveProps) {
  return (
    <GenericSubstantiveProcedures
      workspaceName="Revenue from Operations"
      area="Execution"
      onBack={onBack}
      setActiveSection={setActiveSection}
    />
  );
}
